import { render } from "./Photo_Display.vue?vue&type=template&id=58a4c2c2&scoped=true"
import script from "./Photo_Display.vue?vue&type=script&lang=js"
export * from "./Photo_Display.vue?vue&type=script&lang=js"

import "./Photo_Display.vue?vue&type=style&index=0&id=58a4c2c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a4c2c2"]])

export default __exports__